<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :style="iconStyle"
    class="p-icon"
  >
    <use :xlink:href="`/assets/img/sprite.svg#${name}`" />
  </svg>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 16 },
    color: { type: String, default: 'currentColor' },
  },
  computed: {
    iconStyle() {
      const size = typeof this.size === 'number' ? `${this.size}px` : this.size;
      return {
        width: size,
        height: size,
        fill: this.color,
      };
    },
  },
};
</script>

<style scoped>
.p-icon {
    display: inline-block;
    vertical-align: middle;
}
</style>
